// noinspection DuplicatedCode

import {Runner, RunnerInterface} from '../models/runner';
import {RUNS_HUMAN_READABLE} from '../models/waypoint';
import RunProvider from './run';
import Share from './share';

export default class RenderProvider {
    static instance = null;

    favoritesList: Element;

    favoritesContainer: Element;

    favoritesRowTemplate: Element;

    favoritesTableBody: Element;

    favoritesTimeSwitch: Element;

    distanceSegmentsContainer: Element;

    runnerDetailContainer: Element;

    runnerDetailContentWrapper: Element;

    runnerDetailName: Element;

    runnerDetailTitle: Element;

    runnerDetailImg: HTMLImageElement;

    runnerDetailRun: Element;

    runnerDetailStartnumber: Element;

    runnerDetailRanks: Element;

    runnerDetailRankTotal: Element;

    runnerDetailRankAge: Element;

    runnerDetailCloseButton: Element;

    runnerDetailDeleteButton: Element;

    runnerDetailShareOpenButton: Element;

    runnerDetailShareCloseButton: Element;

    runnerDetailShareSubmitButton: HTMLButtonElement;

    runnerDetailSharePreview: HTMLImageElement;

    searchContainer: Element;

    searchToggleButton: Element;

    searchInput: HTMLInputElement;

    searchResults: Element;

    searchFilterRunOptions: NodeListOf<HTMLInputElement>;

    warningLimitReached: Element;

    loadingContainer: Element;

    runnerCountdown: Element;

    runnerCountdownHeadline: Element;

    runnerCountdownDays: Element;

    runnerCountdownHours: Element;

    runnerCountdownMins: Element;

    runnerCountdownSecs: Element;

    statisticsSpinnerTemplate: Element;

    statisticsDistanceTemplate: Element;

    statisticsDistance: Element;

    statisticsTime: Element;

    statisticsSpeedTemplate: Element;

    statisticsSpeed: Element;

    statisticsEta: Element;

    statisticsEtaTemplate: Element;

    statisticsEtaSwitch: HTMLButtonElement;

    runnerStatistics: Element;

    passedWaypoints: Element;

    passedWaypointsRowTemplate: Element;

    passedWaypointsBody: Element;

    passedWaypointsTimeSwitch: Element;

    statisticsPaceIndicator: Element;

    mapContainer: Element;

    finishTemplate: HTMLTemplateElement;

    private runProvider: RunProvider;

    static getInstance(): RenderProvider {
        if (!this.instance) {
            this.instance = new RenderProvider();
        }

        return this.instance;
    }

    constructor() {
        this.runProvider = RunProvider.getInstance();

        this.favoritesContainer = document.querySelector('.js-race-tracking-favorites-container');
        this.favoritesList = document.querySelector('.js-race-tracking-favorites-list');
        this.favoritesRowTemplate = document.querySelector('.js-race-tracking-favorites-template');
        this.favoritesTableBody = document.querySelector('.js-race-tracking-favorites-table-body');
        this.favoritesTimeSwitch = document.querySelector('.js-race-tracking-favorites-time-switch');
        this.distanceSegmentsContainer = document.querySelector('.js-race-tracking-distance-segments');

        this.runnerDetailContainer = document.querySelector('.js-race-tracking-runner-detail');
        this.runnerDetailContentWrapper = document.querySelector('.js-race-tracking-runner-detail-content');
        this.runnerDetailName = document.querySelector('.js-race-tracking-runner-detail-name');
        this.runnerDetailTitle = document.querySelector('.js-race-tracking-runner-detail-title');
        this.runnerDetailImg = document.querySelector('.js-race-tracking-runner-detail-img');
        this.runnerDetailRun = document.querySelector('.js-race-tracking-runner-detail-run');
        this.runnerDetailStartnumber = document.querySelector('.js-race-tracking-runner-detail-startnumber');
        this.runnerDetailRanks = document.querySelector('.js-race-tracking-runner-detail-ranks');
        this.runnerDetailRankTotal = document.querySelector('.js-race-tracking-runner-detail-rank-total');
        this.runnerDetailRankAge = document.querySelector('.js-race-tracking-runner-detail-rank-age');
        this.runnerDetailCloseButton = document.querySelector('.js-race-tracking-runner-detail-close');
        this.runnerDetailDeleteButton = document.querySelector('.js-race-tracking-runner-detail-delete');
        this.runnerDetailShareOpenButton = document.querySelector('.js-race-tracking-runner-detail-share-open');
        this.runnerDetailShareCloseButton = document.querySelector('.js-race-tracking-runner-detail-share-close');
        this.runnerDetailShareSubmitButton = document.querySelector('.js-race-tracking-runner-detail-share-submit');
        this.runnerDetailSharePreview = document.querySelector('.js-race-tracking-runner-detail-share-preview');

        this.searchContainer = document.querySelector('.js-runner-search-container');
        this.searchToggleButton = document.querySelector('.js-runner-search-toggle');
        this.searchInput = document.querySelector('.js-runner-search-input');
        this.searchResults = document.querySelector('.js-runner-search-results');
        this.searchFilterRunOptions = document.querySelectorAll('.js-runner-search-run-option');
        this.warningLimitReached = document.querySelector('.js-runner-search-limit-reached');

        this.loadingContainer = document.querySelector('.js-race-tracking-container');
        this.runnerCountdown = document.querySelector('.js-race-tracking-countdown');
        this.runnerCountdownHeadline = document.querySelector('.js-race-tracking-countdown-headline');
        this.runnerCountdownDays = document.querySelector('.js-race-tracking-countdown-days');
        this.runnerCountdownHours = document.querySelector('.js-race-tracking-countdown-hours');
        this.runnerCountdownMins = document.querySelector('.js-race-tracking-countdown-mins');
        this.runnerCountdownSecs = document.querySelector('.js-race-tracking-countdown-secs');

        this.runnerStatistics = document.querySelector('.js-runner-statistics');
        this.statisticsSpinnerTemplate = document.querySelector('.js-runner-statistics-spinner');
        this.statisticsDistanceTemplate = document.querySelector('.js-runner-statistics-distance-template');
        this.statisticsDistance = document.querySelector('.js-runner-statistics-distance');
        this.statisticsSpeedTemplate = document.querySelector('.js-runner-statistics-speed-template');
        this.statisticsSpeed = document.querySelector('.js-runner-statistics-speed');
        this.statisticsTime = document.querySelector('.js-runner-statistics-time');
        this.statisticsEtaTemplate = document.querySelector('.js-runner-statistics-eta-template');
        this.statisticsEta = document.querySelector('.js-runner-statistics-eta');
        this.statisticsEtaSwitch = document.querySelector('.js-runner-statistics-eta-switch');
        this.statisticsPaceIndicator = document.querySelector('.js-runner-statistics-pace-indicator');

        this.passedWaypoints = document.querySelector('.js-runner-passed-waypoints');
        this.passedWaypointsRowTemplate = document.querySelector('.js-runner-passed-waypoints-row-template');
        this.passedWaypointsBody = document.querySelector('.js-runner-passed-waypoints-body');
        this.passedWaypointsTimeSwitch = document.querySelector('.js-runner-passed-waypoints-time-switch');

        this.mapContainer = document.querySelector('.js-race-tracking-map-container');
        this.finishTemplate = document.querySelector('.js-race-tracking-finish-template');
    }

    async handleClickShareSubmit() {
        this.runnerDetailShareSubmitButton.disabled = true;

        const runnerDetailShareCanvas = await Share.drawElementToCanvas(this.runnerDetailContentWrapper);

        runnerDetailShareCanvas.toBlob((blob) => {
            Share
                .shareBlob(blob, 'Runner')
                .then(() => {
                    this.runnerDetailContainer.classList.remove('share-context');
                    this.runnerDetailShareSubmitButton.disabled = false;
                })
                .catch(() => {
                    this.runnerDetailShareSubmitButton.disabled = false;
                });
        }, 'image/jpeg', 0.95);
    }

    renderRunnerDetail(
        runner: Runner,
        onClose?: (event: Event) => void,
        onDelete?: (event: Event, deleteRunner: Runner) => void,
    ) {
        if (!runner) return;

        this.searchFilterRunOptions.forEach((radio) => {
            radio.setAttribute('disabled', 'disabled');
        });

        this.runnerDetailContainer.classList.remove('hidden');
        this.favoritesContainer.classList.add('hidden');

        const closeDetail = (event: Event) => {
            onClose?.(event);

            this.hideFinishScreen();
            this.runnerDetailContainer.classList.add('hidden');
            this.favoritesContainer.classList.remove('hidden');

            this.searchFilterRunOptions.forEach((radio) => {
                radio.removeAttribute('disabled');
            });
        };

        window.addEventListener('keyup', (event) => {
            if (event.key === 'Escape') {
                closeDetail(event);
            }
        }, {once: true});

        if (navigator.canShare && CSS.supports('container-type: inline-size')) {
            this.runnerDetailShareOpenButton.classList.remove('hidden');
            this.runnerDetailShareOpenButton.addEventListener('click', async () => {
                this.runnerDetailContainer.classList.add('share-context');
            });

            this.runnerDetailShareCloseButton.addEventListener('click', async () => {
                this.runnerDetailContainer.classList.remove('share-context');
            });

            this.runnerDetailShareSubmitButton.addEventListener('click', this.handleClickShareSubmit.bind(this));
        }

        this.runnerDetailCloseButton.addEventListener('click', (event: Event) => {
            closeDetail(event);
        }, {once: true});

        this.runnerDetailDeleteButton.addEventListener('click', (event: Event) => {
            onDelete?.(event, runner);
            setTimeout(() => closeDetail(event));
        }, {once: true});

        if (!this.runnerDetailName) return;

        this.runnerDetailName.innerHTML = runner.getFullName();
        this.runnerDetailStartnumber.innerHTML = runner.startNumber;
        const humanReadableRun = this.runProvider.translate(RUNS_HUMAN_READABLE[runner.run]);
        this.runnerDetailRun.innerHTML = `${humanReadableRun} ${runner.year}`;
        this.runnerDetailTitle.innerHTML = '';

        let avatar: HTMLImageElement;
        if (runner.profilePictureUrl) {
            avatar = document.createElement('img');
            avatar.src = runner.profilePictureUrl;
        } else {
            avatar = document.createElement('span') as HTMLImageElement;
            avatar.innerHTML = runner.getInitials();
        }
        this.runnerDetailImg.innerHTML = avatar.outerHTML;

        if (runner.isRunRelay()) {
            this.runnerDetailTitle.classList.remove('hidden');
            [0, 1, 2, 3].forEach((relayPosition) => {
                const span: HTMLSpanElement = document.createElement('span');
                span.innerHTML = runner.getFullName(relayPosition);

                this.runnerDetailTitle.append(span);
            });
        } else if (runner.clubName) {
            this.runnerDetailTitle.classList.remove('hidden');
            this.runnerDetailTitle.innerHTML = runner.clubName;
        } else {
            this.runnerDetailTitle.classList.add('hidden');
        }

        if (runner.hasFinished() && runner.hasRankTotal()) {
            this.runnerDetailRanks.classList.remove('hidden');
            this.runnerDetailRankTotal.innerHTML = runner.rankTotal.toString();

            if (runner.hasRankAge()) {
                this.runnerDetailRankAge.classList.remove('hidden');
                this.runnerDetailRankAge.innerHTML = this.runnerDetailRankAge.innerHTML
                    .replace('%ageGroup%', runner.getAgeGroupString())
                    .replace('%rankAge%', runner.rankAge.toString());
            } else {
                this.runnerDetailRankAge.classList.add('hidden');
            }
        } else {
            this.runnerDetailRanks.classList.add('hidden');
        }
    }

    showSearchContext() {
        if (!this.runnerDetailContainer) return;

        this.runnerDetailContainer.classList.add('hidden');
        this.favoritesList.classList.add('hidden');
        this.searchToggleButton.classList.add('hidden');
        this.searchContainer.classList.remove('hidden');
    }

    hideSearchContext() {
        if (!this.searchResults) return;

        this.searchResults.innerHTML = '';
        this.searchResults.classList.add('hidden');
        this.favoritesList.classList.remove('hidden');
        this.searchToggleButton.classList.remove('hidden');
        this.searchContainer.classList.add('hidden');
    }

    static compileSearchResultItem(
        runner: Runner,
        onSelect: (startNumber: string) => void,
        checkIsFavorite: (runnerInterface: RunnerInterface) => boolean,
    ): Element {
        const startNumber = document.createElement('strong');
        startNumber.className = 'race-tracking__search-results-item-startnumber';
        startNumber.innerText = runner.startNumber;

        const name = document.createElement('span');
        name.className = 'race-tracking__search-results-item-name';
        name.innerText = runner.getFullName();

        const button = document.createElement('button');
        button.className = 'race-tracking__search-results-item';
        button.dataset.startNumber = runner.startNumber;
        button.appendChild(startNumber);
        button.appendChild(name);

        if (checkIsFavorite(runner)) {
            button.className += ' race-tracking__search-results-item--is-favorite';
        }

        button.addEventListener('click', () => onSelect(runner.startNumber), {once: true});

        return button;
    }

    renderSearchResultsDropdown(
        runners: Array<RunnerInterface>,
        onSelect: (startNumber: string) => void,
        checkIsFavorite: (runnerInterface: RunnerInterface) => boolean,
    ) {
        if (!this.searchResults) return;

        const suggestions = runners.map((runner) => RenderProvider.compileSearchResultItem(
            new Runner(runner),
            (startNumber: string) => {
                onSelect(startNumber);
                setTimeout(() => {
                    this.hideSearchContext();
                });
            },
            checkIsFavorite,
        ));

        this.searchResults.innerHTML = '';
        this.searchResults.append(...suggestions);

        if (suggestions.length) {
            this.searchResults.classList.remove('hidden');
        } else {
            this.searchResults.classList.add('hidden');
        }
    }

    showLoader() {
        this.loadingContainer.classList.add('is-loading');
    }

    hideLoader() {
        this.loadingContainer.classList.remove('is-loading');
    }

    showFinishScreen() {
        const finishScreen = this.finishTemplate.innerHTML;
        this.mapContainer.insertAdjacentHTML('beforeend', finishScreen);
    }

    hideFinishScreen() {
        const finishScreen = this.mapContainer.querySelector('.js-race-tracking-finish-screen');
        if (finishScreen) {
            this.mapContainer.removeChild(finishScreen);
        }
    }

    showWarningLimitReached() {
        this.warningLimitReached.classList.remove('hidden');
        this.searchToggleButton.classList.add('hidden');
    }

    hideWarningLimitReachedIfVisible() {
        if (!this.warningLimitReached.classList.contains('hidden')) {
            this.warningLimitReached.classList.add('hidden');
            this.searchToggleButton.classList.remove('hidden');
        }
    }
}
